import { render, staticRenderFns } from "./feed_back_addTag_dialog.vue?vue&type=template&id=530a9a9a"
import script from "./feed_back_addTag_dialog.vue?vue&type=script&lang=js"
export * from "./feed_back_addTag_dialog.vue?vue&type=script&lang=js"
import style0 from "./feed_back_addTag_dialog.vue?vue&type=style&index=0&id=530a9a9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports